import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useSeoTags, buildWebPageJsonLd } from '../../hooks/useSeoTags';
import './LegalPage.css';

const PrivacyPage: React.FC = () => {
  const { t } = useTranslation('legal');

  const privacyTitle = t('privacy.title');
  const privacyDescription = t('privacy.sections.intro.content', {
    defaultValue: 'Loopy Privacy Policy.',
  });
  const seoTags = useSeoTags({
    title: privacyTitle,
    description: privacyDescription,
    canonical: '/privacy',
    jsonLd: buildWebPageJsonLd({
      url: '/privacy',
      name: privacyTitle,
      description: privacyDescription,
      breadcrumbs: [
        { name: 'Loopy', url: '/' },
        { name: privacyTitle, url: '/privacy' },
      ],
    }),
  });

  return (
    <div className="legal-page">
      {seoTags}
      <div className="legal-container">
        <div className="legal-header">
          <h1>{t('privacy.title')}</h1>
          <p className="legal-updated">{t('privacy.lastUpdated')}: 2025-01-17</p>
        </div>

        <div className="legal-content">
          <section className="legal-section">
            <h2>{t('privacy.sections.intro.title')}</h2>
            <p>{t('privacy.sections.intro.content')}</p>
          </section>

          <section className="legal-section">
            <h2>{t('privacy.sections.collection.title')}</h2>
            <p>{t('privacy.sections.collection.content')}</p>
            <h3>{t('privacy.sections.collection.personal.title')}</h3>
            <ul>
              <li>{t('privacy.sections.collection.personal.items.0')}</li>
              <li>{t('privacy.sections.collection.personal.items.1')}</li>
              <li>{t('privacy.sections.collection.personal.items.2')}</li>
            </ul>
            <h3>{t('privacy.sections.collection.usage.title')}</h3>
            <ul>
              <li>{t('privacy.sections.collection.usage.items.0')}</li>
              <li>{t('privacy.sections.collection.usage.items.1')}</li>
              <li>{t('privacy.sections.collection.usage.items.2')}</li>
            </ul>
            <h3>{t('privacy.sections.collection.voiceRecording.title')}</h3>
            <ul>
              <li>{t('privacy.sections.collection.voiceRecording.items.0')}</li>
              <li>{t('privacy.sections.collection.voiceRecording.items.1')}</li>
              <li>{t('privacy.sections.collection.voiceRecording.items.2')}</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>{t('privacy.sections.cookies.title')}</h2>
            <p>{t('privacy.sections.cookies.content')}</p>
            <ul>
              <li>{t('privacy.sections.cookies.items.0')}</li>
              <li>{t('privacy.sections.cookies.items.1')}</li>
              <li>{t('privacy.sections.cookies.items.2')}</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>{t('privacy.sections.usage.title')}</h2>
            <p>{t('privacy.sections.usage.content')}</p>
            <ul>
              <li>{t('privacy.sections.usage.items.0')}</li>
              <li>{t('privacy.sections.usage.items.1')}</li>
              <li>{t('privacy.sections.usage.items.2')}</li>
              <li>{t('privacy.sections.usage.items.3')}</li>
              <li>{t('privacy.sections.usage.items.4')}</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>{t('privacy.sections.sharing.title')}</h2>
            <p>{t('privacy.sections.sharing.content')}</p>
          </section>

          <section className="legal-section">
            <h2>{t('privacy.sections.security.title')}</h2>
            <p>{t('privacy.sections.security.content')}</p>
          </section>

          <section className="legal-section">
            <h2>{t('privacy.sections.rights.title')}</h2>
            <p>{t('privacy.sections.rights.content')}</p>
            <ul>
              <li>{t('privacy.sections.rights.items.0')}</li>
              <li>{t('privacy.sections.rights.items.1')}</li>
              <li>{t('privacy.sections.rights.items.2')}</li>
              <li>{t('privacy.sections.rights.items.3')}</li>
              <li>{t('privacy.sections.rights.items.4')}</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>{t('privacy.sections.children.title')}</h2>
            <p>{t('privacy.sections.children.content')}</p>
          </section>

          <section className="legal-section">
            <h2>{t('privacy.sections.changes.title')}</h2>
            <p>{t('privacy.sections.changes.content')}</p>
          </section>

          <section className="legal-section">
            <h2>{t('privacy.sections.contact.title')}</h2>
            <p>{t('privacy.sections.contact.content')}</p>
            <p className="legal-email">privacy@loopyai.app</p>
          </section>
        </div>

        <div className="legal-footer">
          <Link to="/terms" className="legal-link">{t('common.viewTerms')}</Link>
          <Link to="/" className="legal-link">{t('common.backToHome')}</Link>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPage;
